import { apiSlice } from "../apiSlice";

export const advertisementSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Update advertisement
    updateAdvertisement: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `advertisement/${id}`,
        method: "PUT",
        body: { id, ...data },
      }),

      invalidatesTags: (result, error, { id }) => [
        { type: "advertisement", id },
      ],

      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        // Optimistic update for LIST
        const patchResult = dispatch(
          apiSlice.util.updateQueryData(
            "getAdvertisementList",
            undefined,
            (draft) => {
              if (draft.entities[id]) {
                Object.assign(draft.entities[id], patch);
              }
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),

    // ✅ Delete advertisement
    deleteAdvertisement: builder.mutation({
      query: (id) => ({
        url: `advertisement/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          apiSlice.util.updateQueryData(
            "getAdvertisementList",
            undefined,
            (draft) => {
              delete draft.entities[id];
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),

    // ✅ Add advertisement
    addAdvertisement: builder.mutation({
      query: (data) => ({
        url: "advertisement",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData(
              "getAdvertisementList",
              undefined,
              (draft) => {
                draft.entities[data.id] = data;
                draft.ids.push(data.id);
              },
            ),
          );
        } catch (err) {
          console.error("Add advertisement failed:", err);
        }
      },
    }),
  }),
});

export const {
  useUpdateAdvertisementMutation,
  useDeleteAdvertisementMutation,
  useAddAdvertisementMutation,
} = advertisementSlice;
